import { LandingPagePitch } from "@client/pages/home/Home";
import { getOAuthLink } from "../getOAuthLink";
import Container from "./Container";
import GoogleLogo from "./GoogleLogo";
import Layout from "./Layout";
import LoginNavbar from "./LoginNavbar";

export default function Login() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return (
    <Layout>
      <LoginNavbar noAuth />
      <main>
        <Container>
          <LandingPagePitch />

          {!!params.error && (
            <div className="flex flex-col items-center justify-center max-w-[315px] mx-auto pb-7 text-red-500">
              Error: {params.error}
            </div>
          )}
          <div className="flex flex-col items-center justify-center rounded-md bg-[#f0f0f0] dark:bg-[#3a3a3a] border-2 border-gray-500 max-w-[315px] mx-auto pb-7">
            <p className="text-lg font-semibold py-5">Welcome!</p>
            <a
              href={getOAuthLink()}
              className="flex items-center justify-center px-8 rounded-md bg-white dark:bg-[#3a3a3a] shadow-sm border border-black/5 dark:border-white/5 outline-none no-underline"
            >
              <GoogleLogo className="w-6 h-6" />
              <p className="ml-3 py-3">Log in with Google</p>
            </a>
          </div>
        </Container>
      </main>
    </Layout>
  );
}
